import { render, staticRenderFns } from "./RegisterTrainer.vue?vue&type=template&id=1f6b2b69&scoped=true"
import script from "./RegisterTrainer.vue?vue&type=script&lang=js"
export * from "./RegisterTrainer.vue?vue&type=script&lang=js"
import style0 from "./RegisterTrainer.vue?vue&type=style&index=0&id=1f6b2b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6b2b69",
  null
  
)

export default component.exports